/* global axios */
import ApiClient from './ApiClient';

class KanbanBoardsAPI extends ApiClient {
  constructor() {
    super('kanban_boards', { accountScoped: true });
  }

  getBoardData(boardId, filters = {}) {
    return axios.get(`${this.url}/${boardId}/board_data`, { params: filters });
  }

  getOptimizedBoardData(boardId, filters = {}) {
    return axios.get(`${this.url}/${boardId}/optimized_board_data`, {
      params: filters,
    });
  }

  getColumns(boardId) {
    return axios.get(`${this.url}/${boardId}/kanban_columns`);
  }

  createColumn(boardId, columnData) {
    return axios.post(`${this.url}/${boardId}/kanban_columns`, columnData);
  }

  updateColumn(boardId, columnId, columnData) {
    return axios.patch(
      `${this.url}/${boardId}/kanban_columns/${columnId}`,
      columnData
    );
  }

  deleteColumn(boardId, columnId) {
    return axios.delete(`${this.url}/${boardId}/kanban_columns/${columnId}`);
  }

  reorderColumns(boardId, positions) {
    return axios.post(`${this.url}/${boardId}/kanban_columns/reorder`, {
      positions,
    });
  }

  moveConversation(boardId, columnId, conversationId) {
    return axios.post(
      `${this.url}/${boardId}/kanban_columns/${columnId}/move_conversation`,
      {
        conversation_id: conversationId,
      }
    );
  }
}

export default new KanbanBoardsAPI();
